import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import Sound from "react-sound";
import { s3base } from "api.js";
import NoMicrophone from "views/NoMicrophone.jsx";
import ReusableRecorder from "components/Recorder/ReusableRecorder";
import Beep from "Beep.js";
import "components/custom.css";
import MicWaveform from "../MicWaveform";
import RecordedWaveform from "components/Question/Speaking/RecordedWaveform";
import Spinner from "components/Loader/Spinner";
import { isIOSDevice } from 'util/deviceDetection';

const DescribeImage = (props) => {
  const LIMIT = 40;
  const [state, setState] = useState({
    isRecording: false,
    blobURL: "",
    isBlocked: false,
    question: "",
    secondCount: 25,
    recordCount: 0,
    recordId: 1,
    intervalId: 0,
    duration: 0,
    questionId: "",
    reset: false,
    trans: "",
    correctFlag: true,
    soundStatus: false,
    file: "",
    imageLoaded: true,
    micPermitted: null,
    browserAllowed: true,
    question_image: null,
    skip: false,
  });

  const [imageModalOpen, setImageModalOpen] = useState(false);

  const recorderRef = useRef(null);
  const audioContextRef = useRef(null);

  const {
    micPermitted,
    browserAllowed,
    question_image,
    blobURL,
    recordCount,
    saveTranscript,
    soundStatus,
  } = state;
  const { resultMode } = props;

  useEffect(() => {
    console.log("check browser");
    // Check browser. Only Chrome only.
    let chrome =
      /Chrome/.test(navigator.userAgent) &&
      !/Edg/.test(navigator.userAgent) &&
      /Google Inc/.test(navigator.vendor);

    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(() => {
        // Microphone Permission Granted.
        setState((prevState) => ({
          ...prevState,
          isBlocked: false,
          micPermitted: true,
          browserAllowed: true,
          question_image: `data:image/png;base64, ${props.data.image}`,
          reset: false,
        }));
      })
      .catch(() => {
        // Permission Denied
        setState((prevState) => ({
          ...prevState,
          isBlocked: true,
          micPermitted: false,
          browserAllowed: true,
        }));
      });

    return () => {
      clearInterval(state.intervalId);
    };
  }, [props.data.image]);

  // const startProcess = useCallback(() => {
  //   if (!props.answer) {
  //     const intervalId = setInterval(() => {
  //       setState(prevState => {
  //         let state_obj = {};
  //         if (prevState.secondCount === 1) {
  //           clearInterval(prevState.intervalId);
  //           setState(prev => ({ ...prev, soundStatus: true }));
  //           const recordId = setInterval(() => {
  //             setState(p => {
  //               if (p.recordCount === 40) {
  //                 clearInterval(p.recordId);
  //                 // stop recording logic here
  //               }
  //               return { ...p, recordCount: p.recordCount + 1 };
  //             });
  //           }, 1000);
  //           state_obj.recordId = recordId;
  //           state_obj.skip = false;
  //         }
  //         state_obj.secondCount = prevState.secondCount - 1;
  //         return { ...prevState, ...state_obj };
  //       });
  //     }, 1000);
  //     setState((prevState) => ({
  //       ...prevState,
  //       intervalId,
  //       imageLoaded: true,
  //     }));
  //   }
  // }, [props.answer]);

  useEffect(() => {
    if (props.data) {
      if (
        (state.questionId && state.questionId !== props.data.id) ||
        props.restart
      ) {
        clearInterval(state.intervalId);
        clearInterval(state.recordId);

        setState((prevState) => ({
          ...prevState,
          recordCount: 0,
          isRecording: false,
          secondCount: 25,
          questionId: props.data.id,
          blobURL: "",
          reset: true,
          imageLoaded: false,
          trans: "",
          duration: 0,
        }));
      } else if (!state.questionId) {
        setState((prevState) => ({
          ...prevState,
          questionId: props.data.id,
          imageLoaded: false,
        }));
      }
    }
  }, [props.data, props.restart, state.questionId, state.intervalId, state.recordId]);

  // Handle restart like ReadAloud does
  useEffect(() => {
    if (props.restart) {
      props.restartQue();
    }
  }, [props.restart]);

  // ===================================================================
  // NEW: Recording + Beep start together (exactly like RepeatSentence)
  // Recording begins SYNCHRONOUSLY when prep ends.
  // Beep plays at the exact same moment.
  // This eliminates the delay that caused missed initial speech.
  // Re-render for label change ("Recording started") happens AFTER
  // the MediaRecorder has already started → no words lost.
  // ===================================================================
const startRecording = useCallback(() => {
  console.log("inside startRecording");

  if (!recorderRef.current) return;

  recorderRef.current.startRecording();

  // ✅ Set isRecording FIRST, before the interval is created
  setState(prev => ({
    ...prev,
    isRecording: true,
  }));

  const recordId = setInterval(() => {
    setState(p => {
      if (p.recordCount >= 40) {
        clearInterval(p.recordId);
        recorderRef.current?.stopRecording();
        return { ...p, recordCount: 0, isRecording: false };
      }
      // ✅ NEVER touch isRecording here — only own what you need to
      return { ...p, recordCount: p.recordCount + 1 };
    });
  }, 1000);

  // ✅ Set recordId in a separate follow-up, after isRecording is already queued
  setState(prev => ({
    ...prev,
    recordId,
  }));

}, []);

  const handleRecordingComplete = useCallback((recordingData) => {
    const { blob, url, transcript, duration: recordDuration, file } = recordingData;
    
    setState((prev) => ({
      ...prev,
      blobURL: url,
      isRecording: false,
      recordCount: 100,
      file,
      duration: recordDuration,
      trans: transcript || ""
    }));

    const data_to_send = {
      data: file,
      audio_text: transcript || "",
      duration: recordDuration,
      blob_url: url
    };

    if (props.testMode) {
      props.nextQuestion(data_to_send);
    } else {
      props.submit(data_to_send, true);
      props.showResult();
    }
  }, [props]);

  const stop = useCallback(() => {
    if (recorderRef.current && state.isRecording) {
      recorderRef.current.stopRecording();
    }
    if(!props.testMode){
      props.setIsStopped(false)
    }
  }, [state.isRecording]);
  // Updated: now ONLY cleans up the beep (no longer starts recording)
  const handleSongFinishedPlaying = () => {
    setState(prev => ({ ...prev, soundStatus: false }));
  };

  const createAndPlayBeep = useCallback((audioContext) => {
    try {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      oscillator.frequency.value = 800; // 800 Hz beep
      oscillator.type = 'sine';
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.3);

      setTimeout(() => {
        handleSongFinishedPlaying();   // notify parent that beep finished
        setState(prev => ({ ...prev, soundStatus: false }));
      }, 300);
    } catch (error) {
      console.error('Error playing beep sound:', error);
      // Fallback: still call beepComplete and reset beep
      setTimeout(() => {
        handleSongFinishedPlaying();
        setState(prev => ({ ...prev, soundStatus: false }));
      }, 300);
    }
  }, [handleSongFinishedPlaying, soundStatus]);

  const playMobileBeep = useCallback(() => {
      // iOS needs explicit AudioContext resume
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        let audioContext = audioContextRef.current;
        if (!audioContext) {
          audioContext = new AudioContext();
          audioContextRef.current = audioContext;
        }
        if (audioContext.state === 'suspended') {
          audioContext.resume().then(() => {
            createAndPlayBeep(audioContext);
          }).catch(() => {
            createAndPlayBeep(audioContext); // try anyway
          });
        } else {
          createAndPlayBeep(audioContext);
        }
      } catch (error) {
        console.error('iOS beep error:', error);
        setTimeout(() => {
          handleSongFinishedPlaying();
          // setBeep(false);
          setState(prev => ({ ...prev, soundStatus: false }));
        }, 300);
      }
  }, [createAndPlayBeep, handleSongFinishedPlaying, isIOSDevice]);  

  useEffect(() => {
    if (isIOSDevice() && soundStatus) {
      playMobileBeep();
    }
  }, [soundStatus, playMobileBeep, isIOSDevice]);

  // const stopTest = useCallback(async () => {
  //   if (state.isRecording && recorderRef.current) {
  //     recorderRef.current.stopRecording();
  //   } else {
  //     props?.nextQuestion({
  //       data: state.file,
  //       audio_text: state.trans,
  //       duration: state.duration,
  //     });
  //   }
  // }, [state.isRecording, state.file, state.trans, state.duration, props]);

  const updateCorrect = useCallback(() => {
    props.submit({
      data: "",
      audio_text: "",
      duration: state.duration,
    });
    setState((prevState) => ({ ...prevState, correctFlag: false }));
  }, [props, state.duration]);

  // const skip = useCallback(() => {
  //   setState(prevState => {
  //     clearInterval(prevState.intervalId);

  //     if(isIOSDevice()){
  //       playMobileBeep();
  //     }else{
  //       setState(prev => ({ ...prev, soundStatus: true }));
  //     }

  //     setTimeout(() => {
  //       if (!prevState.isBlocked && recorderRef.current) {
  //         recorderRef.current.startRecording();
  //       }
  //       setState(prev => ({ ...prev, soundStatus: false, isRecording: true }));
  //     }, 1000);

  //     const recordId = setInterval(() => {
  //       setState(p => {
  //         if (p.recordCount === 40) {
  //           clearInterval(p.recordId);
  //           if (recorderRef.current) {
  //             recorderRef.current.stopRecording();
  //           }
  //         }
  //         return { ...p, recordCount: p.recordCount + 1 };
  //       });
  //     }, 1000);
      
  //     return {
  //       ...prevState,
  //       recordId,
  //       secondCount: 0,
  //       skip: false,
  //       blobURL: ""
  //     };
  //   });
  // }, []);

  const skip = useCallback(() => {
  setState(prevState => {
    clearInterval(prevState.intervalId);
    return {
      ...prevState,
      secondCount: 0,
      skip: false,
      blobURL: "",
      soundStatus: isIOSDevice() ? prevState.soundStatus : true,
    };
  });

  // ✅ Call startRecording OUTSIDE setState
  setTimeout(() => {
    startRecording();
    if (isIOSDevice()) {
      playMobileBeep();
    }
  }, 0);
}, [startRecording, playMobileBeep]);

  const handleImageLoaded = useCallback(() => {
  if (!props.answer) {
    const intervalId = setInterval(() => {
      // ✅ Use a ref to track secondCount instead of reading from setState
      setState(prevState => {
        if (prevState.secondCount === 1) {
          clearInterval(intervalId); // ✅ use local var, not prevState.intervalId

          // ✅ schedule startRecording OUTSIDE setState using setTimeout(fn, 0)
          setTimeout(() => {
            startRecording();
            if (isIOSDevice()) {
              playMobileBeep();
            } else {
              setState(p => ({ ...p, soundStatus: true }));
            }
          }, 0);

          return {
            ...prevState,
            secondCount: prevState.secondCount - 1,
            skip: false,
          };
        }

        return { ...prevState, secondCount: prevState.secondCount - 1 };
      });
    }, 1000);

    setState(prev => ({ ...prev, intervalId, imageLoaded: true, skip: true }));
  }
}, [props.answer]);

  // const handleImageLoaded = useCallback(() => {

  //   if (!props.answer) {
  //     const intervalId = setInterval(() => {
  //       setState(prevState => {
  //         let state_obj = {};
  //         if (prevState.secondCount === 1) {
  //           clearInterval(prevState.intervalId);
  //           if(isIOSDevice()){
  //             playMobileBeep();
  //           }else{
  //             setState(prev => ({ ...prev, soundStatus: true }));
  
  //             // Start recording immediately when countdown reaches 0
  //             setTimeout(() => {
  //               if (!prevState.isBlocked && recorderRef.current) {
  //                 recorderRef.current.startRecording();
  //                 setState((prev) => ({
  //                   ...prev,
  //                   isRecording: true,
  //                   blobURL: "",
  //                   soundStatus: false,
  //                 }));
  //               }
  //             }, 1000); // Wait for beep to finish
  //           }

  //           const recordId = setInterval(() => {
  //             setState(p => {
  //               if (p.recordCount === 40) {
  //                 clearInterval(p.recordId);
  //                 // Stop recording automatically after 40 seconds
  //                 if (!p.isBlocked && p.isRecording && recorderRef.current) {
  //                   recorderRef.current.stopRecording();
  //                 }
  //               }
  //               return { ...p, recordCount: p.recordCount + 1 };
  //             });
  //           }, 1000);
  //           state_obj.recordId = recordId;
  //           state_obj.skip = false;
  //         }
  //         state_obj.secondCount = prevState.secondCount - 1;
  //         return { ...prevState, ...state_obj };
  //       });
  //     }, 1000);
  //     setState((prevState) => ({
  //       ...prevState,
  //       intervalId,
  //       imageLoaded: true,
  //       skip: true,
  //     }));
  //   }
  // }, [props.answer]);

  const recordingLabelText = (() => {
    const { blobURL, isRecording, secondCount } = state;
    if (blobURL === "" && !isRecording) return `Recording starts in ${secondCount} seconds...`;
    if (isRecording) return "Recording started";
    if (!isRecording && blobURL !== "") return "Recording finished";
    return "";
  })();

  useEffect(() => {
    if (props.restart) {
      props.restartQue();
    }
  }, [props.restart])

  //  useEffect(()=>{
  // if (props.stopRecording) {
  //   console.log("2222");

  //   stopTest();
  // }
  //  },[props.stopRecording])
  // if (props.data) {
  //   console.log("33333");

  //   question = props.data.question;

  // console.log("blobURL===", blobURL);
  // console.log("isRecording==", state.isRecording);

  const showSkipWaitButtonFlag = state.skip && !props.testMode && state.blobURL === "" && !state.isRecording;
  const showStopButtonFlag = !props.testMode && state.isRecording && recordCount !== 0;
  const showRecordedAudioFlag = state.blobURL && !props.testMode;

  const handleRecordingCompleteRef = useRef(null);
  handleRecordingCompleteRef.current = handleRecordingComplete;
  
  const stableHandleRecordingComplete = useCallback((data) => {
    handleRecordingCompleteRef.current(data);
  }, []);

useEffect(() => {
    if (state.correctFlag) {
      updateCorrect();
    }
  }, [state.correctFlag])

  if (state.isBlocked) {
    return <NoMicrophone />;
  }

  return (
    <>
      {micPermitted && browserAllowed ? (
        <>
          <ReusableRecorder
            ref={recorderRef}
            onRecordingComplete={stableHandleRecordingComplete}
            maxDuration={40000}
            enableSpeechRecognition={true}
            fileName={"noname1.mp3"}
          />

          {!resultMode && !isIOSDevice() && soundStatus && (
            <Sound
              url={Beep}
              playStatus={Sound.status.PLAYING}
              onFinishedPlaying={handleSongFinishedPlaying}
              onError={handleSongFinishedPlaying}
            />
          )}

          {
            question_image === "" ? <>
            <div className="pmw-tabs-section pmw-outer-wrapper m-0 loading-wrapper">
						<div className="question-skeleton">
							<Spinner id="mocklist-spinner-question"/>
						</div>
					</div>
            </> : (
              <div className="pmw-tabs-section d-flex align-items-center pmw-outer-wrapper recorded-wrapper logging-system visibility-visible m-0 pb-5 pb-md-0 mock-container">
            <div className="recorded-section describe-image h-100">
              <div className="recorded-content">
                <div
                  className="img-wrapper describe-image-zoom-container"
                  onClick={() => setImageModalOpen(true)}
                >
                  <img
                    alt="media-link"
                    width="500"
                    onLoad={handleImageLoaded}
                    src={question_image}
                  />
                  <div className="describe-image-zoom-overlay">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="11" cy="11" r="8" />
                      <line x1="21" y1="21" x2="16.65" y2="16.65" />
                      <line x1="11" y1="8" x2="11" y2="14" />
                      <line x1="8" y1="11" x2="14" y2="11" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="recorded-section h-100 mock-resource-text">
              <div className="recorded-content">
                <ul className="recorded-list">
                  {/* <li>Status:</li>
                  <li>{recordingLabelText}</li> */}
                   <li>Status:<span className="text-black"> {recordingLabelText}</span></li>
                   {state.isRecording && (
    <li>
      Recording: {LIMIT - recordCount}s
    </li>
  )}
                </ul>
                <div className="recorded-audio-wrapper">
                  {showRecordedAudioFlag ? (
                    <div className="mic-waveform-wrapper" style={{ marginTop: "37px" }}>
                      <RecordedWaveform
                        testMode={false}
                        blobURL={state.blobURL}
                      />
                    </div>
                  ) : (
                    <>
                      {recordCount === 0 ? (
                        // <img src="/images/waveform.png" alt="Waveform" />
                        <div className="waveform" style={{ marginTop: "48px" }}>
      							      {Array.from({ length: 100 }).map((_, i) => (
      							        <div key={i} className="wave-bar" />
      							      ))}
      							    </div>
                      ) : (
                        <MicWaveform
                          progressValue={recordCount * 2.5}
                          striped
                        />
                      )}
                      {showSkipWaitButtonFlag && (
                        <div className="btn-outer mt-0 mt-md-4">
                          <button
                            className="skip-btn visibility-visible"
                            onClick={skip}
                          >
                            Skip
                          </button>
                        </div>
                      )}
                      {showStopButtonFlag && (
                        <div className="btn-outer mt-0 mt-md-4">
                          <button
                            className="skip-btn visibility-visible"
                            onClick={stop}
                          >
                            Stop
                          </button>
                        </div>
                      )}
                      {showRecordedAudioFlag && (
                        <audio
                          src={blobURL}
                          controls="controls"
                          className="mt-2 visibility-visible"
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
            )
          }    
        </>
      ) : (
        <div className="pmw-tabs h-100">
          {micPermitted === false && (
            <div className="alert alert-danger">
              No Microphone permissions granted. Please grant microphone
              permissions and reload the page.
            </div>
          )}
          {/* {browserAllowed === false && (
            <div className="alert alert-danger">
              The browser you are using is not supported. Please use Google
              Chrome.
            </div>
          )} */}
        </div>
      )}

      {imageModalOpen && question_image && (
        <div
          className="image-modal-overlay"
          onClick={() => setImageModalOpen(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            cursor: "pointer",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              maxWidth: "90vw",
              maxHeight: "90vh",
            }}
          >
            <button
              onClick={() => setImageModalOpen(false)}
              style={{
                position: "absolute",
                top: "-40px",
                right: "0",
                background: "none",
                border: "none",
                color: "#fff",
                fontSize: "30px",
                cursor: "pointer",
                fontWeight: "bold",
                lineHeight: 1,
              }}
              aria-label="Close"
            >
              &times;
            </button>
            <img
              src={question_image}
              alt="media-link-enlarged"
              style={{
                maxWidth: "80vw",
                maxHeight: "70vh",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default DescribeImage;


